import React from 'react';
import PropTypes from 'prop-types';
import 'App/components/AccordionWrapper/AccordionWrapper.scss';

const propTypes = {
    title: PropTypes.string.isRequired,
    isVisible: PropTypes.bool,
    onClick: PropTypes.func,
    setIsVisible: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    isVisible: false,
    onClick: null,
    setIsVisible: null,
    className: '',
};

const HeaderContent = ({ onClick, title, isVisible, setIsVisible, className }) => {
    return (
        <button
            type="button"
            className={`${className} accordion-header-h3-title`}
            data-testid="accordion-title"
            onClick={() => {
                setIsVisible(!isVisible);
                onClick?.(!isVisible);
            }}
        >
            <i className={isVisible ? 'fa fa-caret-down' : 'fa fa-caret-right'} style={{ marginRight: '8px' }} />
            <span className={`${className} accordion-header-h3-text`}>{title}</span>
        </button>
    );
};

HeaderContent.propTypes = propTypes;
HeaderContent.defaultProps = defaultProps;

export default HeaderContent;
